"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var styledIs = function (method) { return function (condition) { return function () {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    var isValid = function (props) {
        return names[method](function (name) {
            return typeof name === "string"
                ? name in props
                    ? Boolean(props[name]) === condition
                    : !condition
                : name.valid(props);
        });
    };
    var getCss = function () {
        var styles = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            styles[_i] = arguments[_i];
        }
        return function (props) {
            var style = styles[0], rest = styles.slice(1);
            return isValid(props) ? styled_components_1.css.apply(void 0, __spreadArrays([style], rest)) : styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
        };
    };
    getCss.valid = isValid;
    return getCss;
}; }; };
exports.default = styledIs;
var templateObject_1;
